import defaultConfig from './default.json'
import devConfig from './development.json'
import euConfig from './eu.json'
import prodConfig from './production.json'

const IS_PRODUCTION = window.__ENV__ === 'PRODUCTION'
const IS_QA = window.__ENV__ === 'MASTER'

const localConfigs = {
  QA: devConfig,
  EU: euConfig,
  US: prodConfig,
}

export const isEU = window.DRIFT_REGION === 'EU'

const config: Record<string, any> = {
  ...defaultConfig,
  IS_PRODUCTION,
  IS_QA,
  ...(window.DRIFT_CONFIG || {}),
  ...localConfigs[
    window.DRIFT_REGION || (window.__ENV__ === 'PRODUCTION' ? 'US' : 'QA')
  ],
}

export default config
